import { AxiosResponse } from 'axios'

import {
  ConnectedServiceData,
  ConnectedServiceHealthPlanInfoResponse,
  ConnectedServiceInitialTokenExchangeResponse,
} from '@lyrahealth-inc/shared-app-logic/src/features/connectedService/types'

import { axiosInstance } from '../axiosInstance'

export const getConnectedServicesData = (lyraId: string): Promise<AxiosResponse<ConnectedServiceData[]>> => {
  return axiosInstance.get(`/secured/v1/${lyraId}/connected-services`)
}

export const getConnectedServiceHealthPlanInfo = (
  lyraId: string,
  service: string,
): Promise<AxiosResponse<ConnectedServiceHealthPlanInfoResponse>> => {
  return axiosInstance.get(`/secured/v1/${lyraId}/connected-services/${service}/health-plan-info`)
}

export const exchangeInitialToken = (
  token: string,
  service: string,
  deviceUUID: string,
): Promise<AxiosResponse<ConnectedServiceInitialTokenExchangeResponse>> => {
  return axiosInstance.post(`/unsecured/v1/connected-services/exchange-initial-token`, {
    token,
    service,
    deviceUUID,
  })
}
